import { useCurrentStateAndParams } from "@uirouter/react";

import { Stack } from "@similarweb/ui-components/foundations";

import { useApiQuery } from "app/modules/api-client/useApiQuery";
import { WORLDWIDE_COUNTRY_ID } from "app/services/countryServiceConst";

import type { IDemandAnalysisHomePageParams } from "../../types";

import { TopicsDiscoverHeader } from "./TopicsDiscoverHeader";
import { TopicsDiscoverTrendingSection } from "./TopicsDiscoverTrendingSection";

export const TopicsDiscover = () => {
    const { params } = useCurrentStateAndParams<IDemandAnalysisHomePageParams>();
    const country = params.country ?? WORLDWIDE_COUNTRY_ID;

    const { data, isError, isLoading } = useApiQuery(
        {
            tag: "DemandSearchTrends",
            methodName: "v2MarketResearchDemandAnalysisTrendingList",
        },
        { country },
    );

    return (
        <Stack
            gap="16px"
            data-automation="topics-discover-section"
        >
            <TopicsDiscoverHeader
                country={country}
                userTopic={data?.topic}
                isLoadingTrendingTopics={isLoading}
            />
            <TopicsDiscoverTrendingSection
                data={data}
                isError={isError}
                isLoading={isLoading}
            />
        </Stack>
    );
};
